import { CategoryLlAndLJsEnv } from "./category_ll_and_l_js_env";

// RRサーバにリクエストを送る時に設定する、画面によって変わるパラメータ。
export const setRrRequestParamsForLl = (R3_COMMON: r3_common, pageOption: any, isSoloare?: boolean) => {
  var R3_CATEGORY = new r3_category();
  if (isSoloare) {
    R3_COMMON.addPlacementType('category_page');
  } else {
    R3_COMMON.addPlacementType('category_page.' + pageOption.placementNameLl1);
    R3_COMMON.addPlacementType('category_page.' + pageOption.placementNameLl2);
  }

  R3_CATEGORY.setId(pageOption.categoryCode);
  R3_CATEGORY.setName(pageOption.categoryName);
}

export const setRrRequestParamsForL = (R3_COMMON: r3_common, pageOption: any, isSoloare?: boolean) => {
  var R3_CATEGORY = new r3_category();
  if (isSoloare) {
    R3_COMMON.addPlacementType('category_page');
  } else {
    R3_COMMON.addPlacementType('category_page.' + pageOption.placementNameL1);
    R3_COMMON.addPlacementType('category_page.' + pageOption.placementNameL2);
    R3_COMMON.addPlacementType('category_page.' + pageOption.placementNameL3);
  }

  R3_CATEGORY.setId(pageOption.categoryCode);
  R3_CATEGORY.setName(pageOption.categoryName);
}

export const createRrRequestParam = (model: CategoryLlAndLJsEnv) => {
  const pageOption = model.isLlCategory ? {
    placementNameLl1: model.rrAreaProfileLl1?.placementName,
    placementNameLl2: model.rrAreaProfileLl2?.placementName,
    categoryCode: model.categoryLlCode,
    categoryName: model.categoryLlName,
  } : {
    placementNameL1: model.rrAreaProfileL1?.placementName,
    placementNameL2: model.rrAreaProfileL2?.placementName,
    placementNameL3: model.rrAreaProfileL3?.placementName,
    categoryCode: model.categoryLCode,
    categoryName: model.categoryLName,
  };
  return {
    isLogin: model.isLogin,
    userId: model.userId,
    userTracking: model.userTracking,
    userSegments: model.userSegments,
    setRrRequestParams: model.isLlCategory ? setRrRequestParamsForLl : setRrRequestParamsForL,
    pageOption: pageOption
  };
}
